<script>
    import Icon from 'fa-svelte';
    import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
    import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
    import Color from './Color.svelte';
    import { TYPICAL } from'./colorBlind';

    export let result = { invalidTypes: [], errors: [] };
    
    // https://stackoverflow.com/a/1026087
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
</script>

<style>

    .error-row {
        display: grid;
        grid-template-columns: 1fr 1fr;

        max-width: 20rem;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        padding: 0.25rem;
        margin-bottom: 1rem;
    }

</style>


<div>
    <div class="col-md">
        {#if result.invalidTypes.length}
        <p class="res text-danger"><Icon icon={faExclamationTriangle} /> This palette is not colorblind-safe.</p>
        {:else}
        <p class="res text-secondary"><Icon icon={faCheck} /> This palette is colorblind-safe.</p>
        {/if}
    </div>

    {#if result.invalidTypes.length}
    <div class="col-md">
        <p>The {result.errors.length === 1 ? "color pairing below is" : `${result.errors.length} pairings below are`} difficult to distinguish in one or more colorblind tests</p>
        {#each result.errors.sort((a, b) => a.distanceSim-b.distanceSim) as error, i}
            <div class="error-row">                
                <div>
                    <div class="label">Typical Vision</div>
                    <Color bind:value={error.a} readOnly="true" />
                    <Color bind:value={error.b} readOnly="true" />
                    <div>ΔE*<sub>CMC</sub> = {error.distanceNorm.toFixed(1)} </div>
                </div>

                {#if error.type !== TYPICAL}
                <div>
                    <div class="label">{capitalizeFirstLetter(error.type)}</div>
                    <Color bind:value={error.aSim} readOnly="true" />
                    <Color bind:value={error.bSim} readOnly="true" />    
                    <div>ΔE*<sub>CMC</sub> = <b>{error.distanceSim.toFixed(1)}</b> </div>
                </div>
                {/if}
            </div>
        {/each}

        <p style="margin-top: 1rem; max-width: 40rem">
            <b>ΔE*<sub>CMC</sub></b> is the <a href="https://en.wikipedia.org/wiki/Color_difference#CMC_l:c_.281984.29">color difference</a> as developed by the Colour Measurement Committee of the Society of Dyers and Colourists (CMC) in 1984. We consider any value below <b>9</b> to be too small a color difference to be easily distinguishable.
        </p>
    </div>
    {/if}
</div>
